import React from 'react'
import { IconButton, Paragraph } from '@fs/zion-ui'
import { ContentCheck } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'
import { navButtonCss } from '../navigationButtonNo/NavigationButtonNo'

export default function NavigationButtonYes({ onClick, loading, linkName = '' }) {
  const { t } = useTranslation()
  return (
    <div css={navButtonCss()}>
      <IconButton
        data-testid="review-experience-navigation-button-yes"
        title={t('full-name-correction.step-one-yes', 'Yes')}
        Icon={ContentCheck}
        onClick={onClick}
        color="green"
        emphasis="lightHigh"
        size="lg"
        disabled={loading}
        linkName={linkName}
      />
      <Paragraph size="sm" centered>
        {t('full-name-correction.step-one-yes', 'Yes')}
      </Paragraph>
    </div>
  )
}
